module.exports = __webpack_public_path__ + "static/media/instagram.f263dbf1.svg";